import { ErrorDetail } from '@/types/ErrorTypes'
import { Translator } from '../../types/ApiResponseTypes'
import {
  ErrorResponseData,
  ErrorResponseDetailItem,
  isErrorResponse,
  isErrorResponseData,
} from '@/types/ErrorResponseTypes'

class ErrorResponseTranslator implements Translator<ErrorDetail[]> {
  convert(response: any): ErrorDetail[] {
    const errorDetailList: ErrorDetail[] = []
    if (isErrorResponse(response)) {
      if (typeof response.error === 'string') {
        // Snappy direct
        errorDetailList.push({
          code: response.errorCode ?? 500,
          title: 'Something went wrong',
          detail: response.error ?? 'Something went wrong',
        })
      } else if (response.error && isErrorResponseData(response.error)) {
        const errorData: ErrorResponseData = response.error // Directly use response.error here
        if (typeof errorData.detail === 'string') {
          if (errorData.code === 422) {
            const cleanedString = errorData.detail
              .substring(errorData.detail.indexOf(':') + 2, errorData.detail.length - 2)
              .replace(/\\"/g, '"')
            const jsonObject = JSON.parse(`${cleanedString}`)
            errorDetailList.push({
              code: errorData.code ?? 500,
              title: 'Something went wrong',
              detail: jsonObject,
            })
          } else {
            // try decode
            errorDetailList.push({
              code: errorData.code ?? 500,
              title: 'Something went wrong',
              detail: errorData.detail,
            })
          }
        } else if (Array.isArray(errorData.detail)) {
          // Access detail property
          errorData.detail.forEach((errorItem: ErrorResponseDetailItem) => {
            errorDetailList.push({
              code: errorItem.status ?? 500,
              title: errorItem.title ?? 'Something went wrong',
              detail: errorItem.detail ?? 'Something went wrong',
              source: errorItem.source,
            })
          })
        }
      }
      return errorDetailList
    }
    return errorDetailList
  }
}

export default new ErrorResponseTranslator()
